var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8211 34.8209L44.0143 44.0141M15.5746 4.85156L17.2581 11.1284M11.1286 17.2579L4.84961 15.5744M30.2256 8.7754L25.6279 13.3731M13.3711 25.6277L8.77778 30.2254M19.5006 19.5004L30.3339 45.5004L34.1776 34.1774L45.5006 30.3337L19.5006 19.5004Z",
    stroke: "url(#paint0_linear_1228_10601)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1228_10601",
    x1: 11.5008,
    y1: -5.07329,
    x2: -8.34801,
    y2: 60.8116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB9B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceWebsite);
export default __webpack_public_path__ + "static/media/service-website.a68713a89fb8b5267b6ec81e8fc872a1.svg";
export { ForwardRef as ReactComponent };